import React from 'react';
import { getThemeClass } from '../../../../utils/theme';

const PostForm = ({ 
  post, 
  onChange, 
  theme = 'dark' 
}) => {
  if (!post) {
    return (
      <div className={`p-4 text-center ${getThemeClass(theme, 'text.secondary')}`}>
        Select a post or create a new one
      </div>
    );
  }

  const handleChange = (field) => (e) => {
    onChange(field, e.target.value);
  };

  const inputClass = `w-full px-3 py-2 rounded-md border bg-slate-800/50 
    ${getThemeClass(theme, 'border')} ${getThemeClass(theme, 'text.primary')}
    focus:outline-none focus:ring-2 focus:ring-blue-500/50`;

  return (
    <div className="grid grid-cols-3 gap-4 p-4">
      {/* Title */}
      <div className="col-span-2">
        <label className={`block text-sm font-medium mb-1 ${getThemeClass(theme, 'text.secondary')}`}>
          Title
        </label>
        <input
          type="text"
          value={post.title || ''}
          onChange={handleChange('title')}
          className={inputClass}
          placeholder="Post title"
        />
      </div>

      {/* Slug */}
      <div>
        <label className={`block text-sm font-medium mb-1 ${getThemeClass(theme, 'text.secondary')}`}>
          Slug
        </label>
        <input
          type="text"
          value={post.slug || ''}
          onChange={handleChange('slug')}
          className={inputClass}
          placeholder="post-slug"
        />
      </div>

      {/* Excerpt */}
      <div className="col-span-2">
        <label className={`block text-sm font-medium mb-1 ${getThemeClass(theme, 'text.secondary')}`}>
          Excerpt (summary for list view)
        </label>
        <input
          type="text"
          value={post.excerpt || ''}
          onChange={handleChange('excerpt')}
          className={inputClass}
          placeholder="Brief summary of the post"
        />
      </div>

      {/* Status */}
      <div>
        <label className={`block text-sm font-medium mb-1 ${getThemeClass(theme, 'text.secondary')}`}>
          Status
        </label>
        <div className={`px-3 py-2 rounded-md ${
          post.status === 'PUBLISHED' 
            ? 'bg-green-500/10 text-green-400 border border-green-500/20' 
            : 'bg-amber-500/10 text-amber-400 border border-amber-500/20'
        }`}>
          {post.status === 'PUBLISHED' ? '✓ Published' : '○ Draft'}
        </div>
      </div>

      {/* Pinned Toggle */}
      <div className="col-span-3">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={post.is_pinned || false}
            onChange={(e) => onChange('is_pinned', e.target.checked)}
            className="w-4 h-4 rounded border-slate-600 bg-slate-800 text-blue-500 
              focus:ring-blue-500/50 focus:ring-offset-0"
          />
          <span className={`text-sm ${getThemeClass(theme, 'text.primary')}`}>
            📌 Pin to top of feed
          </span>
          <span className={`text-xs ${getThemeClass(theme, 'text.secondary')}`}>
            (pinned posts always appear first)
          </span>
        </label>
      </div>
    </div>
  );
};

export default PostForm;

